// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"12":"99243472","529":"cc046f28","553":"60f5be33","635":"5ca765e9","644":"856d0462","787":"02f597ea","927":"73559e47","948":"8ffa4492"}[chunkId] + ".chunk.js";
};